// Opciones de entrega del checkout de la tienda (ver CheckoutPage). Se comparte este mapeo
// de etiquetas con las vistas de administracion (lista y detalle de pedidos) y "Mis pedidos".
export const SHIPPING_METHOD_LABELS = {
  recojo_tienda: 'Recojo en tienda',
  delivery: 'Envío a domicilio',
  envio_provincia: 'Envío a provincia',
};

export const shippingMethodLabel = (value) => SHIPPING_METHOD_LABELS[value] || '—';

// Enlace a Google Maps con el punto que el cliente marco en el mapa del checkout.
export const googleMapsLink = (latitude, longitude) => `https://www.google.com/maps?q=${latitude},${longitude}`;
